<template>
  <div>
    <div class="text-subtitle mb-4">Modifier les informations des options.</div>
    <div v-if="data_loaded">
      <div v-if="list_options.list.length === 0" class="text-body-1 text-medium-emphasis mb-4">Aucune option configurée pour ce module.</div>
      <OptionItem v-for="option in list_options.list" :key="option.id" :item="option"></OptionItem>
    </div>

    <v-row>
      <v-col>
        <v-btn color="primary-dark" @click="update_config()" :loading="loading" class="mt-4" block>Enregistrer les modifications</v-btn>
      </v-col>
    </v-row>
    <div v-if="mainStore.authAdmin.isSportipsAdmin">
      <hr />
      <div class="text-h6">Historique des modifications</div>
      <ConfigHistory v-if="list_options.id_module" action="config_options" :id="list_options.id_module" :key="lastFetch"></ConfigHistory>
    </div>
    <v-snackbar v-model="show_snackbar" location="top right" color="dark-green">
      Mise à jour effectuée avec succès !
      <template v-slot:actions>
        <v-btn color="white" variant="text" @click="show_snackbar = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import List_Options from "@/classes/Options/List_Options.class";
import ConfigHistory from "@/components/Administration/ConfigurationModule/ConfigHistory.vue";
import OptionItem from "@/components/Administration/ConfigurationModule/Config_Options/Option_Item.vue";

export default {
  components: { ConfigHistory, OptionItem },
  data() {
    return {
      list_options: new List_Options(),
      data_loaded: false,
      loading: false,
      show_snackbar: false,
      lastFetch: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async update_config() {
      this.loading = true;
      await this.list_options.update_config();
      this.loading = false;
      this.show_snackbar = true;
      this.lastFetch = this.$moment().format("YYYY-MM-DD HH:mm:ss");
    },
  },
  async mounted() {
    this.list_options.id_module = this.mainStore.module.id;
    await this.list_options.fetch_all();
    this.data_loaded = true;
  },
};
</script>

<style lang="sass" scoped></style>
